import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Spline from "@splinetool/react-spline";

const DistributionSection = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const [splineScene, setSplineScene] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSplineScene(
          "https://prod.spline.design/jM7o2L3Jgfh7oSzE/scene.splinecode"
        );
      } else {
        setSplineScene(
          "https://prod.spline.design/5ryg6PyQRrNVEf3k/scene.splinecode"
        );
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-start md:justify-center text-white overflow-hidden md:py-10 px-0 md:px-16">
      <motion.h2
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        className="text-3xl md:text-5xl font-bold font-orbitron uppercase text-center md:my-5"
      >
        <span className="text-white">$ATH</span> DISTRIBUTION
      </motion.h2>

      <div className="h-screen w-full">
        {splineScene && <Spline scene={splineScene} />}
      </div>
    </section>
  );
};

export default DistributionSection;
